import React, { useState } from 'react';
import './CookieBanner.css';

function CookieBanner({ onPrivacy }) {
  const [visible, setVisible] = useState(
    () => !localStorage.getItem('lgpd_consent')
  );

  function handleAccept() {
    localStorage.setItem('lgpd_consent', JSON.stringify({
      status: 'accepted',
      date: new Date().toISOString(),
    }));
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="alertdialog" aria-live="polite" aria-label="Aviso de privacidade">
      <div className="cookie-banner-content">
        <p className="cookie-banner-text">
          Este site utiliza cookies essenciais para autenticação e funcionamento seguro da plataforma,
          em conformidade com a{' '}
          <strong>Lei Geral de Proteção de Dados (LGPD — Lei 13.709/2018)</strong>.
          Não utilizamos cookies de rastreamento ou publicidade.
        </p>
        <div className="cookie-banner-actions">
          <button
            className="cookie-btn cookie-btn--ghost"
            onClick={onPrivacy}
            aria-label="Ver política de privacidade completa"
          >
            Política de Privacidade
          </button>
          <button
            className="cookie-btn cookie-btn--primary"
            onClick={handleAccept}
            aria-label="Aceitar e continuar navegando"
          >
            Aceitar e continuar
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieBanner;
